module.exports = __webpack_public_path__ + "static/img/7_1.cf098fd5.jpg";